module.exports = __webpack_public_path__ + "static/media/user-injured.dd59e793.svg";